import {Component} from '@angular/core';

/* Body only -- HelpDialogComponent supplies the dialog chrome and Okay button. */
@Component({
    selector: 'app-forecast-help',
    templateUrl: './forecast-help.component.html'
})
export class ForecastHelpComponent {
}
